<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="row text-white" style="padding: 15px 150px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Register
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Register" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 700;">
          Register
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Register" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="bg-image" style="padding: 100px 450px; text-align: center;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <q-card class="my-card" flat bordered>
        <q-card-section class="q-pa-md q-mb-sm q-mt-md">
            <q-img
            style="width: 200px;"
            src="img/marina.png"
          />
          <div class="row" style="padding: 0 15px; margin: 30px 0 10px;">
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="nama" outlined placeholder="Nama Depan" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="belakang" outlined placeholder="Nama Belakang" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="email" outlined placeholder="Email" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="hp" outlined placeholder="Nomor HP" type="number" color="purple-12" dense />
            </div>
            <div class="col-12 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Alamat" color="purple-12" dense />
            </div>
            <div class="col-12 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="hp" outlined placeholder="Username" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Password" type="password" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm" style="margin-bottom: 5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Konfirmasi Password" type="password" color="purple-12" dense />
            </div>
          </div>
        </q-card-section>

      <q-separator />

      <q-card-section>
        <div class="row q-mt-sm q-ml-lg q-mr-lg q-mb-sm">
            <div class="col-5 text-left">
                <q-btn no-caps="" color="purple-12" label="Register" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
            </div>
            <div class="col-7 text-right" style="padding-top: 5px;">
                <span style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; color: #777777;">
                    Sudah Punya Akun ?
                </span>
                <q-btn no-caps to="/login" flat style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12px; color: #C039FF; padding-bottom: 10px;" class="btn--no-hover" label="Login" />
            </div>
          </div>
      </q-card-section>
    </q-card>
    </div>
    <div style="padding: 7.5% 25px; text-align: center;" v-if="$q.screen.lt.sm">
        <q-card class="my-card" flat bordered>
        <q-card-section class="q-pa-sm q-mb-xs q-mt-sm">
            <q-img
            style="width: 100px;"
            src="img/marina.png"
          />
          <div class="row" style="padding: 0 15px; margin: 15px 0;">
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="nama" outlined placeholder="Nama Depan" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="belakang" outlined placeholder="Nama Belakang" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="email" outlined placeholder="Email" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="hp" outlined placeholder="Nomor HP" type="number" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-12 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Alamat" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-12 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="hp" outlined placeholder="Username" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Password" type="password" color="purple-12" dense style="font-size: 10px;" />
            </div>
            <div class="col-6 q-pa-xs" style="margin-bottom: 2.5px;">
                <q-input class="input-font" v-model="alamat" outlined placeholder="Konfirmasi Password" type="password" color="purple-12" dense style="font-size: 10px;" />
            </div>
          </div>
        </q-card-section>

      <q-separator />

      <q-card-section>
        <div class="row q-mt-xs q-ml-sm q-mr-sm q-mb-xs">
            <div class="col-4 text-left">
                <q-btn no-caps="" color="purple-12" label="Register" style="font-family: 'Manrope'; font-size: 12.5px; font-weight: bold;" />
            </div>
            <div class="col-8 text-right" style="padding-top: 10px;">
                <span style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; color: #777777;">
                    Sudah Punya Akun ?
                </span>
                <q-btn no-caps to="/login" flat style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; color: #C039FF; padding-top: 2.5px;" class="btn--no-hover" label="Login" />
            </div>
          </div>
      </q-card-section>
    </q-card>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue'
// import SearchView from '@/views/SearchView.vue'

export default {
  name: 'RegisterView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
        counter: 1,
        produk : '',
        ingat: ref(false),
        id : this.$route.params.id,
        judul : this.$route.params.judul,
        list_produk : [{id : '1', judul : 'Buah Nangka', harga : '40.000', diskon : '53.000'}, {id : '2', judul : 'Kursi Rotan', harga : '120.000', diskon : '150.000'}, {id : '3', judul : 'Nasi Goreng', harga : '20.000', diskon : '23.000'}]
    }
  },

  methods: {
    getView() {
        console.log(this.id);
        console.log(this.judul);
    },
    changeCounter: function(num){
        this.counter += +num
        console.log(this.counter)
        !isNaN(this.counter) && this.counter > 0 ? this.counter : this.counter = 0;
    }
  },

  mounted() {
    this.getView();
    this.changeCounter();
  }

}
</script>
